import intlTelInput from "intl-tel-input";
import "./utils.js";
import "intl-tel-input/build/css/intlTelInput.css";

const inputs = document.querySelectorAll("#phone");
let arr = [];

if (inputs) {
    inputs.forEach(input => {
        intlTelInputFunc(input);
    });
}

export function intlTelInputFunc(input) {
    input.placeholder = "+38 050 123 45 67";
    const iti = intlTelInput(input, {
        initialCountry: "auto",
        geoIpLookup: callback => {
            fetch("https://ipapi.co/json")
                .then(res => res.json())
                .then(data => callback(data.country_code))
                .catch(() => callback("us"));
        }
    });

    arr.push(iti);

    input.addEventListener("input", formatInput);

    function formatInput(event) {
        const input = event.target;
        let value = input.value.replace(/\D/g, "");
        value = value.match(/.{1,3}/g)?.join(" ") || value;
        input.value = value;
    }
}

export function getIntlTelInput() {
    return arr;
}
